/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cut_TitleInputs */



/**
* | output |
* | --- |
* | "Cut Event/Text" |
*
* @param {Cut_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const cut_title = /** @type {((inputs?: Cut_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cut_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Couper Evenement/Texte")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignis/Text ausschneiden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Taglia evento/testo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вырезать событие/текст")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cortar evento/texto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("剪切事件/文本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベント/テキストの切り取り")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट/टेक्स्ट को काटें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Recortar evento/texto")
	return /** @type {LocalizedString} */ ("Cut Event/Text")
});